import Link from 'next/link';
import { popularSearches } from '@/data/popularSearches.data';
import styles from '../searchBar.module.scss';

type Props = {
  onSelect: () => void;
};

const PopularSearches = ({ onSelect }: Props) => {
  if (popularSearches.length === 0) return null;

  return (
    <div className={styles.popularSearches}>
      <p className={styles.popularSearchesTitle}>Popular searches</p>
      <div className={styles.popularSearchesList}>
        {popularSearches.map((item) => (
          <Link
            key={item.id}
            href={item.href}
            className={styles.popularSearchChip}
            onClick={() => onSelect()}
          >
            {item.title}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default PopularSearches;
